module.exports = __webpack_public_path__ + "static/media/ruangguru-products.cb7bd954.jpg";